import script from "./Img2Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Img2Video.vue?vue&type=script&setup=true&lang=js"

import "./Img2Video.vue?vue&type=style&index=0&id=1c365642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c365642"]])

export default __exports__